//====================================================
//  Function: Benefits
//====================================================
function componentTopBanner() {
  // Category
  if (
    $(".type-category").length &&
    $(".sidebar-inner.margin-top-2").length == 0
  ) {
    setTimeout(() => {
      if ($(".box-topProducts").length) {
        $(".box-topProducts").insertAfter($(".sidebar .sidebar-inner"));
        $(".box-topProducts").wrap(
          '<div class="sidebar-inner margin-top-2"></div>'
        );
      }
    }, 500);
  }

  if ($(".type-index").length && $(".sidebar-inner.margin-top-2").length == 0) {
    setTimeout(() => {
      if ($(".box-topProducts").length) {
        $(".box-topProducts").insertAfter($(".sidebar .sale-block"));
        $(".box-topProducts").wrap(
          '<div class="sidebar-inner margin-top-2"></div>'
        );
      }
    }, 500);
  }
}
